import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";
import { Ed, Reveal } from "../Editorial";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

// El descuento de bienvenida, a la vista. El código se enseña entero y se
// puede copiar de un toque: el cliente decide en qué clase lo gasta, así que
// tiene que poder llevárselo sin apuntarlo a mano.

export const PromoBanner = () => {
  const { t } = useLang();
  const p = t.pricing;
  const [promo, setPromo] = useState(null);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    axios.get(`${API}/promo`).then((r) => setPromo(r.data && r.data.code ? r.data : null)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!copiado) return;
    const id = setTimeout(() => setCopiado(false), 2000);
    return () => clearTimeout(id);
  }, [copiado]);

  if (!promo) return null;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(promo.code);
      setCopiado(true);
    } catch {
      // Sin permiso de portapapeles el código sigue a la vista para copiarlo a mano.
    }
  };

  return (
    <Reveal className="mt-12 md:mt-16">
      <div
        data-testid="promo-banner"
        className="relative overflow-hidden border border-[#C5A059]/45 bg-gradient-to-br from-[#C5A059]/[0.10] via-[#C5A059]/[0.04] to-transparent px-6 md:px-10 py-8 md:py-10"
      >
        {/* Un halo dorado detrás, para que el bloque no sea un recuadro más */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(197,160,89,0.22), transparent 70%)" }}
        />

        <div className="relative flex flex-wrap items-center justify-between gap-y-8 gap-x-10">
          <div className="min-w-0 max-w-xl">
            <p className="text-[0.6rem] uppercase tracking-[0.35em] text-[#C5A059]">{p.promoOverline}</p>
            <h3 className="mt-4 font-serif text-3xl md:text-4xl text-white leading-tight">
              <Ed text={p.promoTitle} />
            </h3>
            <p className="mt-4 text-sm text-zinc-400 font-light leading-relaxed">{p.promoBody}</p>
          </div>

          <div className="shrink-0">
            <p className="text-[0.6rem] uppercase tracking-[0.3em] text-zinc-500">{p.promoCodeLabel}</p>
            <button
              onClick={copiar}
              data-testid="promo-code"
              className="mt-3 group flex items-center gap-4 border border-dashed border-[#C5A059]/60 px-6 py-4 hover:bg-[#C5A059]/10 transition-colors duration-300"
            >
              <span className="font-serif text-3xl md:text-4xl tracking-[0.12em] text-[#C5A059]">{promo.code}</span>
              <span className="text-[0.55rem] uppercase tracking-[0.25em] text-zinc-500 group-hover:text-[#C5A059] transition-colors duration-300">
                {copiado ? p.promoCopied : p.promoCopy}
              </span>
            </button>
            <p className="mt-3 text-[0.6rem] uppercase tracking-[0.25em] text-zinc-600">{p.promoOnce}</p>
            <Link
              to="/book"
              data-testid="promo-cta"
              className="mt-5 inline-block border border-[#C5A059]/50 px-7 py-3 text-[0.6rem] uppercase tracking-[0.3em] text-[#C5A059] hover:bg-[#C5A059] hover:text-black transition-colors duration-500"
            >
              {p.promoCta}
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  );
};
